document.addEventListener("DOMContentLoaded", () => {

    function get_cookie(cookie_name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cookie_name}=`);
        if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
        return '';
    }

    function getShopifyBaseImageUrl(li) {
        // beim ersten Lauf: vorhandenes Theme-IMG merken
        if (!li.dataset.mhBaseImg) {
            const themeImg = li.querySelector('img:not(.mh-render)');
            const src = themeImg?.currentSrc || themeImg?.src || '';
            if (src) {
                li.dataset.mhBaseImg = normalizeUrl(src);
            }
        }
        return li.dataset.mhBaseImg || '';
    }

    function normalizeUrl(url) {
        // Shopify liefert oft //cdn... -> mach es zu https://...
        if (url.startsWith('//')) return 'https:' + url;
        return url;
    }

    function drawCover(ctx, img, cw, ch) {
        // "cover" wie CSS background-size: cover
        const iw = img.naturalWidth || img.width;
        const ih = img.naturalHeight || img.height;
        if (!iw || !ih) return;

        const scale = Math.max(cw / iw, ch / ih);
        const w = iw * scale;
        const h = ih * scale;
        const x = (cw - w) / 2;
        const y = (ch - h) / 2;

        ctx.drawImage(img, x, y, w, h);
    }

    function loadImage(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = url;
        });
    }


    function getCityFromCookie() {
        const slug = get_cookie('mh_subdomain');
        if (!slug) return null;

        return {
            slug,
            name: slug
                .split('-')
                .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                .join(' ')
        };
    }

    const gallery = document.querySelector('.l4pr');

    if (!gallery) return;
    if (!gallery.dataset.mhTemplate) return;

    const raw = (gallery.dataset.mhTemplate || "").trim();
// falls aus irgendeinem Grund außen '...' oder "..." dran kleben:
    const cleaned = raw.replace(/^['"]|['"]$/g, '');
    const template = JSON.parse(cleaned);

    function applyTransform(text, transform) {
        if (!transform) return text;
        if (transform === "upper") return text.toUpperCase();
        if (transform === "lower") return text.toLowerCase();
        if (transform === "title") {
            return text.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
        }
        return text;
    }

    //----------------------------------------
    // Canvas Render
    //----------------------------------------

    async function renderMeineHeimat() {
        console.log('[MH] render start');

        const city = getCityFromCookie();
        if (!city) return;

        await document.fonts.ready;

        const allLis = gallery.querySelectorAll('.swiper-slide li');
        if (!allLis.length) return;

        for (const li of allLis) {
            await renderLi(li, city);
        }

        window.dispatchEvent(new Event('resize'));
    }
    async function renderLi(li, city) {
        const baseUrl = getShopifyBaseImageUrl(li);

        const canvas = document.createElement('canvas');
        canvas.width = template.canvas.width;
        canvas.height = template.canvas.height;
        const ctx = canvas.getContext('2d');

        // Background (dieses LI-eigene Shopify Bild)
        if (baseUrl) {
            try {
                const bg = await loadImage(baseUrl);
                drawCover(ctx, bg, canvas.width, canvas.height);
            } catch (e) {
                console.warn('[MH] Background failed', baseUrl, e);
            }
        }

        // Layers
        for (const layer of template.layers) {
            if (layer.type === "image") await drawImage(ctx, layer);
            if (layer.type === "text")  await drawText(ctx, layer, city);
        }

        // Replace image inside THIS li
        const dataURL = canvas.toDataURL("image/png");
        const link = li.querySelector('a');
        if (!link) return;

        let img = li.querySelector('img.mh-render');
        if (!img) {
            const pic = li.querySelector('picture');
            if (pic) pic.remove();

            img = document.createElement('img');
            img.className = 'mh-render';
            img.alt = (li.querySelector('img')?.alt) || 'Preview';
            img.loading = 'eager';
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.display = 'block';
            link.appendChild(img);
        }

        img.src = dataURL;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        link.href = dataURL;
    }

    //----------------------------------------
    // Helpers
    //----------------------------------------

    function drawImage(ctx, layer) {

        return new Promise(resolve => {

            const img = new Image();
            img.crossOrigin = "anonymous";

            img.onload = () => {

                ctx.drawImage(
                    img,
                    layer.box.x,
                    layer.box.y,
                    layer.box.w,
                    layer.box.h
                );

                resolve();
            };

            img.src = layer.src;
        });
    }

    function resolveText(layer, city) {

        if (layer.source === "fixed") {
            return layer.value;
        }

        if (layer.source.startsWith("city.")) {

            const key = layer.source.split('.')[1];
            let val = city[key];

            if (!val) return "";

            if (layer.prefix) {
                val = layer.prefix + val;
            }

            if (layer.suffix) {
                val = val + layer.suffix;
            }

            return val;
        }

        return "";
    }

    function fillTextWithKerningAndTracking(ctx, layer, text, x, y, letterSpacing, fontSizePx) {
        const ls = Number(letterSpacing || 0);
        let cx = x;

        for (let i = 0; i < text.length; i++) {
            const ch = text[i];
            const prev = i > 0 ? text[i - 1] : '';
            const kern = getKerningAdjust(layer, prev, ch, fontSizePx);

            cx += kern;
            ctx.fillText(ch, cx, y);

            cx += ctx.measureText(ch).width;
            if (i < text.length - 1) cx += ls;
        }
    }


    function measureTextWithKerningAndTracking(ctx, layer, text, letterSpacing, fontSizePx) {
        if (!text) return 0;
        const ls = Number(letterSpacing || 0);
        let w = 0;

        for (let i = 0; i < text.length; i++) {
            const ch = text[i];
            const prev = i > 0 ? text[i - 1] : '';
            w += ctx.measureText(ch).width;
            w += getKerningAdjust(layer, prev, ch, fontSizePx);
            if (i < text.length - 1) w += ls;
        }
        return w;
    }


    function getKerningAdjust(layer, prevChar, currChar, fontSizePx) {
        const pairs = layer?.kerning_pairs || null;
        if (!pairs || !prevChar || !currChar) return 0;

        // 1) exakter Key (case-sensitive)
        let key = `${prevChar}${currChar}`;
        let v = pairs[key];

        // 2) fallback: Uppercase-Paarung (für Fälle wie "Va" aber nur "VA" gepflegt)
        if (v == null) {
            key = `${prevChar.toUpperCase()}${currChar.toUpperCase()}`;
            v = pairs[key];
        }

        // 3) fallback: Lowercase-Paarung
        if (v == null) {
            key = `${prevChar.toLowerCase()}${currChar.toLowerCase()}`;
            v = pairs[key];
        }

        if (v == null) return 0;

        // Zahlen robust lesen (auch wenn als String mit Komma geliefert)
        const em = (typeof v === 'string')
            ? parseFloat(v.replace(',', '.'))
            : Number(v);

        if (!Number.isFinite(em)) return 0;

        return em * (Number(fontSizePx) || 0);
    }

    async function drawText(ctx, layer, city) {

        let text = resolveText(layer, city);
        text = applyTransform(text, layer.text_transform);
        if (!text) return;

        await document.fonts.load(`10px ${layer.font.family}`);

        ctx.fillStyle = layer.color || "#000";
        ctx.textBaseline = "middle";

        const align = layer.align || "center";
        const letterSpacing = layer.letter_spacing ?? 0;

        let fontSize =
            layer.fit?.font_size ??
            layer.fit?.max_font ??
            180;

        const minFont = layer.fit?.min_font ?? 40;
        const hasFixedFont = layer.fit?.font_size != null;

        ctx.font = `${fontSize}px ${layer.font.family}`;

        // Auto shrink (mit Tracking messen!)
        if (!hasFixedFont) {
            while (measureTextWithKerningAndTracking(ctx, layer, text, letterSpacing, fontSize) > layer.box.w && fontSize > minFont) {
                fontSize -= 4;
                ctx.font = `${fontSize}px ${layer.font.family}`;
            }
        }

        // X-Start je nach Align berechnen
        const textWidth = measureTextWithKerningAndTracking(ctx, layer, text, letterSpacing, fontSize);

        ;
        let x = layer.box.x;

        if (align === "center") {
            x = layer.box.x + (layer.box.w - textWidth) / 2;
        } else if (align === "right") {
            x = layer.box.x + layer.box.w - textWidth;
        }

        // Y (wie vorher)
        const y = layer.box.y + layer.box.h / 2;

        // Render
        ctx.textAlign = "left"; // wichtig, weil wir selbst positionieren
        // erst Tracking anwenden (optional), dann Kerning (paarweise)
// -> einfacher: wir integrieren Tracking in die Kerning-Renderfunktion:
        fillTextWithKerningAndTracking(ctx, layer, text, x, y, letterSpacing, fontSize);


    }


    //----------------------------------------
    // INITIAL RENDER
    //----------------------------------------

    renderMeineHeimat();

    //----------------------------------------
    // Variant Change Re-Render
    //----------------------------------------

    document.addEventListener('change', (e) => {

        if (e.target.name === "variant-id") {

            setTimeout(renderMeineHeimat, 200);
        }

    });

});
